import React from 'react';

import { TableCell, TableHead, TableRow } from '@gogame/components';

import { SpanNoWrap } from './styled';

const CELL_WIDTH = '1%';

const AffectedEntitiesHead = ({
  secondaryAffectedLevel,
  affectedLevel,
  actionMetrics,
  metrics,
}) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell width={secondaryAffectedLevel ? CELL_WIDTH : null}>
          {affectedLevel}
        </TableCell>
        {secondaryAffectedLevel ? (
          <TableCell>{secondaryAffectedLevel}</TableCell>
        ) : null}

        {actionMetrics.map(({ name }, i) => (
          <React.Fragment key={'head_' + i}>
            <TableCell width={CELL_WIDTH} align={'right'}>
              <SpanNoWrap>{`Current ${name}`}</SpanNoWrap>
            </TableCell>
            <TableCell width={CELL_WIDTH} align={'right'}>
              <SpanNoWrap>{`New ${name}`}</SpanNoWrap>
            </TableCell>
          </React.Fragment>
        ))}

        {[
          {
            name: 'Previous Runs',
            align: 'left',
            style: { width: '140px', display: 'block' },
          },
          ...metrics,
        ].map(({ name, isCompared, align, style = {} }, i) => (
          <TableCell
            style={style}
            key={'headMetrics_' + i}
            width={CELL_WIDTH}
            align={align || 'right'}
            colSpan={isCompared ? 3 : 1}
          >
            <SpanNoWrap>{name}</SpanNoWrap>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default AffectedEntitiesHead;
